import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const rioSulTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#1b567c',
    },
    secondary: {
      main: '#f8b519',
    },
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#b9222c',
    },
  },
};
